var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.hasDefaultSlot)?_vm._t("default",null,null,{ moment: _vm.moment }):_c('span',[_vm._v(_vm._s(_vm.renderDate()))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }